export enum BadgeType {
  DirittoOnly = 'DirittoOnly',
  DirittoOriginal = 'DirittoOriginal',
  New = 'New',
  Up = 'Up',
  Adult = 'Adult',
  AdultBox = 'AdultBox',
  Completed = 'Completed',
  Published = 'Published',
  Hidden = 'Hidden',
  Contest = 'Contest',
  ContestChallenge = 'ContestChallenge',
  Contest2024Top30 = 'Contest2024Top30',
  Contest2024Top7 = 'Contest2024Top7',
  Contest2024 = 'Contest2024',
  ProposalWanted = 'ProposalWanted',
}

export enum BadgeDisplayPolicy {
  All = 'All',
  AdultOnly = 'AdultOnly',
}
